import React, { useEffect } from 'react'
import 'reactjs-popup/dist/index.css'
import { StyledPopup } from './style'
import {
	ReclamationContactFormHeader,
	ReclamationContactFormTitle,
	ReclamationContactFormClose,
	ReclamationContactFormBody,
	ReclamationControlWrapper,
} from '../ReclamationContactForm/style'
import { Icon } from '../Icon'
import { useSelector, useDispatch } from 'react-redux'
import { useIntl } from 'react-intl'
import ReactHtmlParser from 'react-html-parser'
import {
	postWindowMessage,
	getTokenData,
	getSupportEmail,
	getShopPropertiesName,
	SS,
} from '../../utils/common'
import { FormattedMessage } from 'react-intl'
import { EmailPopupP } from '../../containers/Login/style'
import { PopupContent } from './style'
import { isObject } from 'lodash'
import { push } from 'connected-react-router'
import { ButtonFull } from '../Form/Button'
import { SwiperSliderForPopup } from '../../containers/Exchange/components/ExchangeItem/style'
import ReactIdSwiperCustom from 'react-id-swiper/lib/ReactIdSwiper.custom'
import { Preview } from '../../containers/Exchange/components/ExchangeItem/style'
import { swiperOptionsForPopup } from 'configs/config'

let getTitleByDefault = () => {
	return (
		<FormattedMessage
			id={'login.emailSent.header'}
			defaultMessage={'Link Sent To Your Email'}
		/>
	)
}

let getContentByDefault = () => {
	return (
		<PopupContent>
			<FormattedMessage
				id={'login.emailSent.text'}
				defaultMessage={
					"<p>An e-mail with a link to view your orders has been sent to you, follow the link in the e-mail to start creating your return.</p><p>If you haven't received your e-mail within 3 minutes we couldn't match your e-mail to an order.</p>"
				}
				values={{
					p: (chunks) => <EmailPopupP>{chunks}</EmailPopupP>,
				}}
			/>
		</PopupContent>
	)
}

export const PopupWindow = ({
	content = getContentByDefault(),
	title = getTitleByDefault(),
	onClose = null,
	closeOnDocumentClick,
	closeOnEscape,
	popupType = '',
	...rest
}) => {
	let onOpenEvent = () => {
		if (onClose) {
			let status = getStatus(error)
			let overlay = document.querySelector('[data-testid="overlay"]')
			let closeHandling = (e) => {
				if (e.key === 'Escape') {
					clearSSToken(status, error)
					onClose()
				}
				document.removeEventListener('keyup', closeHandling, false)
			}
			if (overlay) {
				overlay.addEventListener('click', (e) => {
					if (e.target.dataset.testid === 'overlay') {
						clearSSToken(status, error)
						onClose()
						document.removeEventListener(
							'keyup',
							closeHandling,
							false
						)
					}
				})
			}
			document.addEventListener('keyup', closeHandling, false)
		}
	}
	const { error, isVisible } = useSelector((state) => state.popup)
	const { wrapperUrl } = useSelector((state) => state.root)
	const intl = useIntl()
	const dispatch = useDispatch()
	/**
	 * removeLasAddedItem {Function}
	 * @description - remove last added item from the cart.
	 * Necessary in case of error from server side to prevent ability to continue work flow with corrupted item
	 * @param {Number}
	 * @param {Object}
	 *
	 * */
	let removeLasAddedItem = (status, error) => {
		try {
			let stepsStoreClone = SS.get('steps')
			let partialRequestDataClone =
				stepsStoreClone.partialRequestData || {}
			let returnOrderClone = partialRequestDataClone.returnOrder || {}
			let returnedItemsArrayClone = returnOrderClone.items
			let lastAddedItem =
				returnedItemsArrayClone[returnedItemsArrayClone.length - 1]
			if (lastAddedItem) {
				document
					.querySelector(
						`[data-id="${lastAddedItem.orderItemId}_clicker"]`
					)
					.click()
			}
		} catch (e) {
			console.error(
				e,
				`wrong handling of the error: ${error}, status: ${status} on popup closing`
			)
		}
	}

	let clearSSToken = (status, error = null) => {
		if (status === 401) {
			sessionStorage.removeItem('token')
			if (window && window.parent && wrapperUrl && error && isVisible) {
				postWindowMessage(wrapperUrl, {}, 'returnadoWidgetClose')
			}
		}

		if (status === 422) {
			if (
				error.message.includes('Return order') &&
				error.message.includes('already exist')
			) {
				sessionStorage.removeItem('steps')
				dispatch(push('/orders'))
			}

			if (
				error.message.includes('period expired.') &&
				error.message.includes('Action unavailable.')
			) {
				removeLasAddedItem(status, error)
			}
		}

		if (status === 500 && !error.type) {
			removeLasAddedItem(status, error)
		}
	}

	let getStatus = (errorData) => {
		return errorData
			? isObject(errorData.error) && errorData.error.headerStatus
				? errorData.error.headerStatus
				: errorData.headerStatus
				? errorData.headerStatus
				: ''
			: ''
	}

	useEffect(() => {
		if (window && window.parent && wrapperUrl && error && isVisible) {
			postWindowMessage(
				wrapperUrl,
				{
					error,
					title: getPopupTitle(error),
					content: getPopupContent(error),
				},
				'returnadoErrorWidgetHandling'
			)
		}
	}, [error, isVisible])

	/**
	 * isPeriodExpirationError {Function}
	 * @description - Basic functionality to define is error about period expiration
	 * @return {Boolean}
	 *
	 * */
	let isPeriodExpirationError = (errData) => {
		let isPeriodExpirationError = false

		if (errData && errData.message) {
			let messageArr = errData.message.split('.')
			if (
				messageArr.length === 3 &&
				messageArr[1].trim() === 'Action unavailable'
			) {
				isPeriodExpirationError = true
			}
		}

		return isPeriodExpirationError
	}

	/**
	 * getProper422ErrorTitle {Function}
	 * @description - Basic functionality to get proper error title based on status. For now just for status 422
	 *
	 * */
	let getProper422ErrorTitle = (errData) => {
		let defaultTitle = 'Something went wrong'

		if (isPeriodExpirationError(errData)) {
			if (errData.message.includes('REFUND')) {
				defaultTitle = intl.formatMessage({
					id: 'orders.returnNotAllowed.dialog.title.refund',
					defaultMessage: 'Refund not possible',
				})
			}

			if (errData.message.includes('EXCHANGE')) {
				defaultTitle = intl.formatMessage({
					id: 'orders.returnNotAllowed.dialog.title.exchange',
					defaultMessage: 'Exchange not possible',
				})
			}

			if (errData.message.includes('RECLAMATION')) {
				defaultTitle = intl.formatMessage({
					id: 'orders.returnNotAllowed.dialog.title.complaint',
					defaultMessage: "Product complaint can't be registered",
				})
			}
		}

		return defaultTitle
	}

	/**
	 * getProper422ErrorContent {Function}
	 * @description - Basic functionality to get proper error content based on status. For now just for status 422
	 * @return {String}
	 * */
	let getProper422ErrorContent = (errData) => {
		let defaultContent = errData.message
		let shopProperties = SS.get('shopProperties')

		if (isPeriodExpirationError(errData)) {
			if (errData.message.includes('REFUND')) {
				defaultContent = intl.formatMessage(
					{
						id: 'orders.returnNotAllowed.dialog.text.refund',
						defaultMessage:
							"This item can't be returned since your purchase has passed its cancellation period of 14 days.",
					},
					{
						days: shopProperties['refund.allowed.period'],
					}
				)
			}

			if (errData.message.includes('EXCHANGE')) {
				defaultContent = intl.formatMessage(
					{
						id: 'orders.returnNotAllowed.dialog.text.exchange',
						defaultMessage:
							"This item can't be exchanged since the purchase has passed it's allowed period of exchange of {days} days.",
					},
					{
						days: shopProperties['exchange.allowed.period'],
					}
				)
			}

			if (errData.message.includes('RECLAMATION')) {
				defaultContent = intl.formatMessage(
					{
						id: 'orders.returnNotAllowed.dialog.text.complaint',
						defaultMessage:
							"A complaint for this product can't be made since the purchase has passed the allowed period of complaint of {days} days.",
					},
					{
						days: shopProperties['reclamation.allowed.period'],
					}
				)
			}
		}

		return defaultContent
	}

	let getPopupTitle = (errorData) => {
		let titleStr = 'Something went wrong'
		let status = getStatus(errorData)

		if (status && !errorData.type) {
			switch (status) {
				case 401:
					return 'Unauthorized'
				case 403:
					return 'Access forbidden'
				case 404:
					return 'No order could be found'
				case 422:
					return getProper422ErrorTitle(errorData)
				case 500:
					return intl.formatMessage({
						id: 'refundFail.dialog.title',
						defaultMessage: 'Something went wrong',
					})
				case 501:
				case 502:
				case 503:
				case 504:
				case 505:
					return title
				default:
					return title
			}
		}

		if (errorData && errorData.type) {
			switch (errorData.type) {
				case 'terms':
					return intl.formatMessage({
						id: 'login.form.termsAndConditions.link',
						defaultMessage: 'Terms and Conditions',
					})
				case 'policy':
					return intl.formatMessage({
						id: 'login.form.privacyPolicy.link',
						defaultMessage: 'Privacy Policy',
					})
				case 'imageSizeError':
					return intl.formatMessage({
						id: 'reclamation.file.upload.wrongSizePopup.header',
						defaultMessage: "You're image couldn't be uploaded",
					})
				case 'returnedItemPopup':
					return intl.formatMessage({
						id: 'orders.alreadyReturned.dialog.title',
						defaultMessage: 'Status of return',
					})
				case 'pendingItemPopup':
					return intl.formatMessage({
						id: 'orders.item.notDelivered.dialog.title',
						defaultMessage: 'Your product hasn’t been shipped yet',
					})
				case 'zoom':
					return errorData.name
				case 'incorrectShopId':
					return intl.formatMessage({
						id: 'widget.incorrect.shop.id.token.error.title',
						defaultMessage: 'Wrong Login Data',
					})
			}
		}
		return titleStr
	}

	/**
	 * isButtonVisible {Function}
	 * @param {Object}
	 * @description - define do we need to show additional button
	 * @return {Boolean}
	 * */
	let isButtonVisible = (errorData) => {
		let isButtonVisible = false
		let status = getStatus(errorData)

		if (status === 404) {
			isButtonVisible = true
		}

		if (
			status === 422 &&
			errorData.message &&
			errorData.message.includes('period expired') &&
			errorData.message.includes('Action unavailable')
		) {
			isButtonVisible = true
		}

		if (
			!errorData &&
			isVisible &&
			title.props.id === 'login.emailSent.header'
		) {
			isButtonVisible = true
		}

		if (
			errorData &&
			errorData.type &&
			errorData.type === 'returnedItemPopup'
		) {
			isButtonVisible = true
		}

		if (
			errorData &&
			errorData.type &&
			errorData.type === 'pendingItemPopup'
		) {
			isButtonVisible = true
		}

		if (
			errorData &&
			errorData.type &&
			errorData.type === 'imageSizeError'
		) {
			isButtonVisible = true
		}

		return isButtonVisible
	}

	let getPopupContent = (errorData) => {
		let contentStr =
			'Resource temporary unavailable, please, try again later'
		let status = getStatus(errorData)

		if (status && !errorData.type) {
			switch (status) {
				case 401:
					return 'Unauthorized or User session expired, please, login again.'
				case 403:
					return 'You don’t have rights to perform this operation.'
				case 404:
					return ReactHtmlParser(
						intl.formatMessage({
							id: 'login.loginFail.text',
							defaultMessage: `We can't find any orders associated with your e-mail or order number, fill in a correct e-mail or order number and try again.`,
						})
					)
				case 422:
					return getProper422ErrorContent(errorData)
				case 500:
					return ReactHtmlParser(
						intl.formatMessage(
							{
								id: 'refundFail.dialog.text',
								defaultMessage:
									'Unfortunately something went wrong, please try again. If problem persists please contact {ReturnadoConsumerSupportEmail}',
							},
							{
								ReturnadoConsumerSupportEmail: getSupportEmail(),
							}
						)
					)
				case 501:
				case 502:
				case 503:
				case 504:
				case 505:
					return content
				default:
					return content
			}
		}

		if (errorData && errorData.type) {
			switch (errorData.type) {
				case 'terms':
					return ReactHtmlParser(
						intl.formatMessage({
							id: 'login.termsAndConditions.text',
							defaultMessage: '',
						})
					)
				case 'policy':
					return <div>{ReactHtmlParser(errorData.data.text)}</div>
				case 'imageSizeError':
					return intl.formatMessage({
						id: 'reclamation.file.upload.wrongSizePopup.text',
						defaultMessage:
							'The image will not upload unless it is in GIF, PNG or JPG format and has maximum size of 15 Mb',
					})
				case 'returnedItemPopup':

					return ReactHtmlParser(
						intl.formatMessage(
							{
								id: 'orders.alreadyReturned.dialog.text',
								defaultMessage:
									'This product has already been returned, you’ll get an email confirmation when your returns has been received and handled. <br /><br /> If you have any questions please contact {shopName} support on {shopSupportEmail}.',
							},
							{
								shopName:
									getShopPropertiesName() ||
									getTokenData()?.customer?.shopId,
								shopSupportEmail: getSupportEmail(),
							}
						)
					)
				case 'pendingItemPopup':
					return intl.formatMessage(
						{
							id: 'orders.item.notDelivered.dialog.text',
							defaultMessage:
								'This product hasn’t been shipped to you yet, as soon as you’ve received your product you’ll be able to do a return. If you have any questions please contact {shopName} support on {shopSupportEmail}.',
						},
						{
							shopName:
								getShopPropertiesName() ||
								getTokenData()?.customer?.shopId,
							shopSupportEmail: getSupportEmail(),
						}
					)
				case 'zoom':
					return (
						<SwiperSliderForPopup className='popupSlider'>
							<ReactIdSwiperCustom
								{...swiperOptionsForPopup}
								rebuildOnUpdate={true}
							>
								{errorData?.images?.map((url, idx) => (
									<Preview className='swiper-slide' key={idx}>
										<img
											className='bigImg'
											src={url}
											alt={idx}
										/>
									</Preview>
								))}
							</ReactIdSwiperCustom>
						</SwiperSliderForPopup>
					)
				case 'incorrectShopId':
					return intl.formatMessage({
						id: 'widget.incorrect.shop.id.token.error.text',
						defaultMessage: `You're trying to enter order using data for another merchant`,
					})
			}
		}
		return contentStr
	}

	return (
		<StyledPopup
			{...rest}
			position={'bottom center'}
			closeOnDocumentClick={closeOnDocumentClick}
			closeOnEscape={closeOnEscape}
			nested
			modal
			onOpen={onOpenEvent}
		>
			{(close) => {
				const closeEvent = (errorData) => {
					let status = getStatus(errorData)
					clearSSToken(status, error)
					if (onClose) {
						onClose()
					}
					close()
				}
				/*const mutableContent = {
					...content,
					props: {
						...content.props,
						onClose: closeEvent,
					},
				}*/
				return (
					<>
						<ReclamationContactFormHeader>
							<ReclamationContactFormTitle className='modal'>
								<ReclamationContactFormClose
									onClick={() => {
										closeEvent(error)
									}}
								>
									<Icon component='closePopup' />
								</ReclamationContactFormClose>{' '}
								{error
									? getPopupTitle(error)
									: title
									? title
									: ''}
							</ReclamationContactFormTitle>
						</ReclamationContactFormHeader>
						<ReclamationContactFormBody
							className={`col-md-12 col-sm-12 modal modal_${
								error?.type || popupType
							}`}
						>
							{error
								? getPopupContent(error)
								: content
								? content
								: ''}

							{isButtonVisible(error) ? (
								<ReclamationControlWrapper>
									<ButtonFull
										w100
										onClick={() => {
											closeEvent(error)
										}}
										dark
										className='modalButton'
									>
										<FormattedMessage
											id='gcFinal.dialog.ok.button'
											defaultMessage='OK'
										/>
									</ButtonFull>
								</ReclamationControlWrapper>
							) : (
								''
							)}
						</ReclamationContactFormBody>
					</>
				)
			}}
		</StyledPopup>
	)
}
